/// <amd-module name="Repos/Views/Branches/Components/Favorite/FavoriteStarButton" />
import * as React from "react";
import * as Resources from "Repos/Views/Branches/Resources";
import { Button } from "VSSUI/Button";
import { Icon, IconSize } from "VSSUI/Icon";
import { IFavoriteStarButtonProps } from "./FavoriteStarButton.Props";

export const FavoriteStarStatic: React.FunctionComponent<{}> = props => {
    return (
        <Icon
            className="repos-favorite-star"
            iconName="FavoriteStarFill"
            size={IconSize.medium}
            tooltipProps={{ text: Resources.TooltipDefaultBranch }}
        />
    );
};

export const FavoriteStarButton: React.FunctionComponent<IFavoriteStarButtonProps> = props => {
    const { className, onClick, isFavorite } = props;

    return (
        <Button
            ariaLabel={isFavorite ? Resources.RemoveFromFavorites : Resources.AddToFavorites}
            className={className}
            iconProps={{
                className: "repos-favorite-star",
                iconName: isFavorite ? "FavoriteStarFill" : "FavoriteStar",
                size: IconSize.medium
            }}
            onClick={onClick}
            subtle={true}
            tooltipProps={{ text: isFavorite ? Resources.RemoveFromFavorites : Resources.AddToFavorites }}
        />
    );
};
